import React from "react";

function EmailIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.6668 4.66699L8.67283 8.48499C8.46942 8.60313 8.23839 8.66536 8.00316 8.66536C7.76794 8.66536 7.5369 8.60313 7.3335 8.48499L1.3335 4.66699M2.66683 2.66699H13.3335C14.0699 2.66699 14.6668 3.26395 14.6668 4.00033V12.0003C14.6668 12.7367 14.0699 13.3337 13.3335 13.3337H2.66683C1.93045 13.3337 1.3335 12.7367 1.3335 12.0003V4.00033C1.3335 3.26395 1.93045 2.66699 2.66683 2.66699Z"
        stroke="black"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default EmailIcon;
